export const normalizeCurrencyValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  if (typeof value === "number" && !Number.isNaN(value)) {
    return value;
  }
  const numeric = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(numeric) ? null : numeric;
};

export const ensurePercentSuffix = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  const str = String(value).trim();
  if (!str) return "";
  return str.endsWith("%") ? str : `${str}%`;
};
